import { queryOptions } from '@tanstack/react-query';

import { ONE_MINUTE } from '@/constants/time';
import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

type GetMessageRelayTargetsV2Params =
  paths['/v2/inquiries/{conversationId}/relay-targets']['get']['parameters']['path'];

export type MessageRelayTargetsV2 =
  paths['/v2/inquiries/{conversationId}/relay-targets']['get']['responses'][200]['content']['application/json']['data'];

export type MessageRelayTargetV2 = MessageRelayTargetsV2['targets'][number];

export async function getMessageRelayTargetsV2({ conversationId }: GetMessageRelayTargetsV2Params) {
  const { data } = await fetchClient.GET('/v2/inquiries/{conversationId}/relay-targets', {
    params: { path: { conversationId } },
  });

  return data?.data;
}

/**
 * The threads a message here may be relayed into. Keyed by the acting account,
 * because only Ask Anonymously has targets and staff switch in and out of it.
 * Callers enable it only for Primum staff on an Ask Anonymously thread.
 */
export function getMessageRelayTargetsV2QueryOptions(
  userId: string | undefined,
  { conversationId }: GetMessageRelayTargetsV2Params,
  enabled: boolean
) {
  return queryOptions({
    queryKey: ['messageRelayTargetsV2', userId, conversationId],
    queryFn: () => getMessageRelayTargetsV2({ conversationId }),
    staleTime: ONE_MINUTE,
    retry: false,
    enabled: enabled && !!userId,
  });
}
